import React from 'react'
import Sidebar from '../Components/Sidebar'
import Emails from '../Components/Email';


function RateManagement() {




  return (

    <Sidebar>
             <div className='container-fluid'> 
             <Emails  />
             </div>
    </Sidebar>
   
  )
}

export default RateManagement;